import { DestroyRef, Directive, ElementRef, inject, input } from '@angular/core';
import { Intercom, MenusService, UserActivityService } from '../services';
import { Router } from '@angular/router';
import { combineLatest, fromEvent, switchMap } from 'rxjs';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';
import { isNotNull } from '../utils';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IDWallMedia, IMenuWithPages } from '../models';

@Directive({
  selector: '[dwallClickableMedia]',
  standalone: true,
})
export class DwallClickableMediaDirective {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly router = inject(Router);
  private readonly menus = inject(MenusService);
  private readonly intercom = inject(Intercom);
  private readonly userActivity = inject(UserActivityService);
  private readonly destroyRef = inject(DestroyRef);

  public readonly specialOfferLink = input.required<string[]>({
    alias: 'dwallClickableMedia',
  });

  constructor() {
    fromEvent(this.elementRef.nativeElement, 'click', { passive: true }).pipe(
      switchMap((event: Event) => {
        return combineLatest([
          this.menus.getMenuForCurrentMedia(),
          this.intercom.currentMedia$,
        ]).pipe(
          take(1),
          filter(([menu, media]) => {
            return isNotNull(menu) && isNotNull(media);
          }),
          distinctUntilChanged(),
          map(([menu, media]) => (
            {
              event: event as MouseEvent,
              menu: menu as IMenuWithPages[],
              media: media as IDWallMedia,
            }
          )),
        );
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(({ event, menu, media }) => {
      this.userActivity.trackClick(
        event,
        'Clickable Media',
        media?.name ?? 'Unknown Media',
        menu?.[0]?.name ?? 'Unknown Menu',
      );

      void this.router.navigate(this.specialOfferLink());
    });
  }

}
